import { Heading, VStack, Text } from '@chakra-ui/react'

const NoAction = () => {
  return (
    <VStack m={'2rem'} justifyContent={'center'} minW={{ base: 'md', md: 'lg', lg: 'lg' }}>
      <Heading fontSize={'2xl'}> No Action For Now</Heading>
      <Text>Request Opponent to Make the Move 🏃</Text>
    </VStack>
  )
}
export default NoAction
